import React, { FC, memo } from 'react';
import RadioButton from 'Components/RadioButton';
import injectSheet from 'react-jss';
import styleSheet from './styles';
import { areEqual } from '../../../utils/areEqual';

interface Props {
  children?: any;
  label?: string;
  value: string;
  identifier?: string;
  selected: boolean;
  onClick?: (event: any) => void;
  classes?: any;
  overrideStyles?: {
    marginTop?: string;
    marginRight?: string;
    marginBottom?: string;
    marginLeft?: string;
    paddingLeft?: string;
    color?: string;
  };
}

const FilterRadioHidden: FC<Props> = (props: Props) => {
  const {
    label,
    identifier,
    selected,
    value,
    onClick,
    classes,
    children,
    overrideStyles,
  } = props;

  const handleClick = () => {
    onClick({ target: { value, id: identifier } });
  };

  // If you want to override the active colour, use overrideStyles.color
  const activeColor =
    overrideStyles && overrideStyles.color ? overrideStyles.color : '#085FE5';

  return (
    <div className={classes.filterRadioHidden}>
      <div className={classes.filterRadioButton}>
        <RadioButton
          selectedColor={activeColor}
          isChecked={selected}
          onClick={handleClick}
          id={`${value}-${identifier}`}
          value=""
        >
          {label && (
            <label
              active-color={activeColor}
              className={classes.filterRadioLabel}
              htmlFor={`${value}-${identifier}`}
            >
              {label}
            </label>
          )}
        </RadioButton>
      </div>
      {children && (
        <div className={classes.filterHiddenContent}>{children}</div>
      )}
    </div>
  );
};

FilterRadioHidden.defaultProps = {
  children: undefined,
  label: undefined,
  onClick: () => {},
  classes: {},
  overrideStyles: {},
  identifier: undefined,
};

export default injectSheet(styleSheet)(memo(FilterRadioHidden, areEqual));
